import { render, staticRenderFns } from "./vc-pie.vue?vue&type=template&id=1723fbe8&scoped=true&"
import script from "./vc-pie.vue?vue&type=script&lang=js&"
export * from "./vc-pie.vue?vue&type=script&lang=js&"
import style0 from "./vc-pie.vue?vue&type=style&index=0&id=1723fbe8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723fbe8",
  null
  
)

export default component.exports